import { render, staticRenderFns } from "./uploadImgTips.vue?vue&type=template&id=976ec35e&scoped=true"
import script from "./uploadImgTips.vue?vue&type=script&lang=js"
export * from "./uploadImgTips.vue?vue&type=script&lang=js"
import style0 from "./uploadImgTips.vue?vue&type=style&index=0&id=976ec35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976ec35e",
  null
  
)

export default component.exports